import getConfig from 'next/config';

import isRelativePath from './isRelativePath';
import parseLocalizedUrl from './parseLocalizedUrl';

/**
 *
 * @param {string} url
 * @param {string} locale
 * @return {string}
 */
export default (url, locale) => {
  const { publicRuntimeConfig } = getConfig();
  if (isRelativePath(url)) {
    const parsedUrl = parseLocalizedUrl(url);
    if (parsedUrl === undefined) {
      return `/${locale}${url}`;
    }
    if (parsedUrl.locale === publicRuntimeConfig.defaultLanguage) {
      return parsedUrl.path;
    }
  }
  return url;
};
